import { stripNonNumeric } from '../helpers/StringHelpers';

export function optimizedPaintListMocker() {
    const optimizedPaintListId = stripNonNumeric(prompt('Typ een lakbon-ID'));
    return JSON.stringify({
        context: 'optimizedPaintList',
        optimizedPaintListId,
    });
}

export function productMocker(camera) {
    const id = prompt('Typ een product ID, camera: ' + camera);
    return JSON.stringify({
        context: 'product',
        productId: id,
    });
}

export function paintWorkFormMocker() {
    const id = prompt('Typ een lakwerkorder ID');
    return JSON.stringify({ context: 'paintworkform', paintworkformId: id });
}

export function articleMocker() {
    const articleCode = prompt('Typ een artikelcode');
    return JSON.stringify({ context: 'article', articleCode });
}

export function stockLocationMocker() {
    const stocklocationId = prompt('Typ een stocklocatie-ID');
    return JSON.stringify({ context: 'stockLocation', stocklocationId });
}

export function productOrLocationMocker() {
    const id = prompt(
        'Typ een product ID of een locatie ID voorafgaand door ST'
    );
    if (id.toUpperCase().startsWith('ST')) {
        return JSON.stringify({
            context: 'stockLocation',
            stocklocationId: stripNonNumeric(id),
        });
    } else {
        return JSON.stringify({ context: 'product', productId: id });
    }
}

export function pleatingListMocker() {
    const pleatinglistId = prompt('Typ een plooibon-ID');
    return JSON.stringify({ context: 'pleatinglist', pleatinglistId });
}
